import React, { useReducer } from "react";
import distribucionesReducer from "./distribucionesReducer.js";
import distribucionesContext from "./distribucionesContext.js";

import { getAbmDistribucion, uploadAbmDistribucion, getAbmSubcuentaDistribucion } from "../../api/abmDistribution.js";

import {
    ACTUALIZAR_DISTRIBUCIONES,
    ACTUALIZAR_SUBCUENTAS_DISTRIBUCION,
    ACTUALIZAR_DISTRIBUCIONES_DB,
    CARGANDO_DISTRIBUCIONES,
    ERROR_DISTRIBUCIONES,
    LIMPIAR_ERROR_DISTRIBUCIONES
} from "./distribucionesActions.js";

const DistribucionesState = props => {

    const initialState = {
        distribuciones: [],
        subcuentasDistribucion: [],
        cargando: false,
        error: ""
    };

    const [state, dispatch] = useReducer(distribucionesReducer, initialState);

    const actualizarDistribuciones = async () => {
        try {
            const resp = await getAbmDistribucion();
            dispatch({
                type: ACTUALIZAR_DISTRIBUCIONES,
                payload: resp.data.data
            });
            return resp.data.data;
        } catch (error) {
            console.log(error);
        }
    };

    const actualizarSubcuentasDistribucion = async () => {
        try {
            const resp = await getAbmSubcuentaDistribucion();
            dispatch({
                type: ACTUALIZAR_SUBCUENTAS_DISTRIBUCION,
                payload: resp.data.data
            });
            return resp.data.data;
        } catch (error) {
            console.log(error);
        }
    };

    const actualizarDistribucionesDB = async () => {
        try {
            await uploadAbmDistribucion();
            const resp = await getAbmDistribucion();
            dispatch({
                type: ACTUALIZAR_DISTRIBUCIONES_DB,
                payload: resp.data.data
            });
            return { status: true, msg: "Se actualizó con éxito la base de datos." };
        } catch (error) {
            console.log(error);
            dispatch({
                type: ERROR_DISTRIBUCIONES,
                payload: error.response?.data?.errMsg || error.message
            });
            return { status: false, msg: error.response?.data?.errMsg || error.message };
        }
    };

    const cargando = () => {
        dispatch({ type: CARGANDO_DISTRIBUCIONES });
    };

    const limpiarError = () => {
        dispatch({ type: LIMPIAR_ERROR_DISTRIBUCIONES });
    };

    return (
        <distribucionesContext.Provider
            value={{
                distribuciones: state.distribuciones,
                subcuentasDistribucion: state.subcuentasDistribucion,
                isCargando: state.cargando,
                error: state.error,
                actualizarDistribuciones,
                actualizarSubcuentasDistribucion,
                actualizarDistribucionesDB,
                cargando,
                limpiarError
            }}
        >
            {props.children}
        </distribucionesContext.Provider>
    );
};

export default DistribucionesState;
